import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { RemoteRecordDataType } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import { State } from 'b2b-apps/shop/common/redux/types';
import {
  CloneWishlistType,
  RemoveWishlistItemsType,
  WishlistDetailedType,
  WishlistType,
} from 'b2b-common/core/account/api/wishlists';
import { AddItemsToCartType } from 'b2b-common/core/cart/api/CartTypes';
import { WishlistState } from './types';

export const getState = (state: State): WishlistState => state.myAccount.wishlists.wishlist;

export const getWishlists = (
  state: State,
): Record<string, RemoteRecordDataType<WishlistType>> => getState(state).wishlists;

export const getWishlist = (
  state: State, wishlistId: string,
): RemoteRecord<WishlistDetailedType> => new RemoteRecord(getWishlists(state)[wishlistId]);

export const getAddItemsToCartData = (
  state: State,
): RemoteRecord<AddItemsToCartType> => new RemoteRecord(getState(state).addItemsToCart);

export const getRemoveWishlistItemsData = (
  state: State,
): RemoteRecord<RemoveWishlistItemsType> => new RemoteRecord(getState(state).removeWishlistItems);

export const getCloneWishlistData = (
  state: State,
): RemoteRecord<CloneWishlistType> => new RemoteRecord(getState(state).cloneWishlist);
